import { types } from 'features/notifications/store/types'

const initialState = () => ({
  list: []
})

const notificationReducer = (state = initialState(), action) => {
  let list, ids, seen

  switch (action.type) {
    case types.SET_NOTIFICATIONS:
      list = action.payload || []
      seen = true
      for (let notification of list) {
        if (!notification.seen) {
          seen = false
          break
        }
      }
      return {
        ...state,
        list,
        seen
      }

    case types.SET_NOTIFICATIONS_READ:
      ids = action.payload.ids || []
      list = state.list.map(n => {
        if (ids.indexOf(n.id) !== -1) {
          n.read = action.payload.read
        }
        return n
      })
      return {
        ...state,
        list
      }

    default:
      break
  }
  return state
}

export default notificationReducer



// WEBPACK FOOTER //
// ./src/features/notifications/store/reducer.js